import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { uploadLayoutData } from "../../../../../services/vehicleMasterService";
import { MessageType } from "../../../../../Constant";

export class LayoutCreate extends React.Component {
    constructor(props) {
        super(props);
        const updateSelection = props.updateSelection || {};

        this.state = {
            form: {},
            layoutName: updateSelection.name || '',
            layoutId: updateSelection.layoutId || '',
            seatingCapacity: updateSelection.seatingCapacity || '' ,
            invalidJson: false,
            loading: false,
            layoutFile: null,
            errorMessage: '',
            supportedTypes: [".csv"]
        };

        this.formData = new FormData();
    }

    componentDidMount() {
        this.mounted = true;
        this.updateFormErrorState();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    updateFormErrorState = () => {
        const { layoutName, layoutFile, seatingCapacity } = this.state;
        const invalid = !layoutName || !layoutFile || !seatingCapacity;
        this.setState(prev => ({
            form: { ...prev.form, invalid }
        }));
    };

    handleNameChange = (e) => {
        this.setState({ layoutName: e.target.value }, this.updateFormErrorState);
    };
    handleCapacityChange = (e) => {
        const value = e.target.value;
        if (value === '' || /^\d+$/.test(value)) {
            this.setState({ seatingCapacity: value }, this.updateFormErrorState);
        }
    };


    isValidFileName = (fileName) => {
        return fileName.toLowerCase().endsWith(".csv");
    };

    browserSupportFileUpload = () => {
        return !!(window.File && window.FileReader && window.FileList && window.Blob);
    };

    onFileChange = (e) => {
        this.setState({ invalidJson: false });

        const file = e.target.files[0];

        if (!this.browserSupportFileUpload()) {
            alert("The File APIs are not fully supported in this browser!");
            return;
        }

        if (!file || !this.isValidFileName(file.name)) {
            this.setState({
                invalidJson: true,
                errorMessage: `Invalid file. Only .xlsx files are allowed.`
            });
            return;
        }

        this.formData.set("file", file, file.name);
        this.setState({ layoutFile: file, invalidJson: false }, this.updateFormErrorState);
    };


    createLayoutMaster = () => {
        this.setState({ loading: true });

        uploadLayoutData(this.state, this.props.updateSelection)
            .then((res) => {
                if (this.mounted) {
                    console.log(res);
                    this.setState({ loading: false });
                    this.props.onComplete(MessageType.SUCCESS, res);
                }
            })
            .catch((err) => {
                this.props.onComplete(MessageType.ERROR, (err.description ? err.description : "Error occurred "));
            });
    };


    render() {
        const { updateSelection, onClose } = this.props;
        const { layoutName,seatingCapacity, form, loading, errorMessage, invalidJson, supportedTypes } = this.state;

        return (
            <div className="container-fluid">
                <form className="row">
                    <div className="col-sm-12 mb-3">
                            <label htmlFor="layout" className="control-label col-sm-2 form-label me-2">Layout Name</label>
                            <div className="col-sm-9">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="layout"
                                    autoComplete="off"
                                    placeholder="Enter Layout Name"
                                    value={layoutName}
                                    onChange={this.handleNameChange}
                                    readOnly={!!updateSelection}
                                />
                            </div>
                    </div>
                    <div className="col-sm-12 mb-3">
                            <label htmlFor="capacity" className="control-label col-sm-2 form-label me-2">Seating Capacity</label>
                            <div className="col-sm-9">
                                <input
                                    type="number"
                                    className="form-control"
                                    id="capacity"
                                    autoComplete="off"
                                    placeholder="Enter Seating Capacity"
                                    value={seatingCapacity}
                                    onChange={this.handleCapacityChange}
                                    min='1'
                                />
                            </div>
                    </div>

                    <div className="col-sm-12 mb-3">
                            <label htmlFor="layoutFile" className="control-label col-sm-2 form-label me-2">Layout File (.csv)</label>
                            <div className="col-sm-8">
                                <div className="file-upload">
                                    <input
                                        type="file"
                                        id="layoutFile"
                                        accept={supportedTypes.join(",")}
                                        onChange={this.onFileChange}
                                    />
                                    {invalidJson && <small className="text-danger">{errorMessage}</small>}
                                </div>
                            </div>
                    </div>

                    <div className="col-sm-12 form-view">
                        <Button onClick={onClose} bsPrefix="close-btn">Close</Button>
                        <Button
                            bsPrefix="confirm-btn"
                            onClick={this.createLayoutMaster}
                            disabled={form.invalid || loading}
                        >
                            {loading ? "Saving..." : "Save changes"}
                        </Button>
                    </div>
                </form>
            </div>
        );
    }
}

LayoutCreate.propTypes = {
    updateSelection: PropTypes.object,
    onComplete: PropTypes.func,
    onClose: PropTypes.func
};